export var HubChannel = /*#__PURE__*/ function(HubChannel) {
    HubChannel["NOTIFICATIONS"] = "eclipsenotifications";
    HubChannel["NEW_FEEDBACK"] = "mcfeedbacknew";
    HubChannel["DREAMSOFART"] = "dreamsofart";
    HubChannel["DREAMSOFART_INPAINT"] = "dreamsofartinpaint";
    HubChannel["CHATUNREAD"] = "chatunread";
    HubChannel["BATCH_COMPLETE"] = "batchcomplete";
    return HubChannel;
}({});

//# sourceMappingURL=types.js.map